import api from './api';
import type { ContractDeal, DealWithFiles } from '../types/contracts';

interface DateRangeParams {
  from: string;
  to: string;
}

export const contractsApi = {
  async getContractDeals(params: DateRangeParams): Promise<ContractDeal[]> {
    const { data } = await api.get('/contracts', { params });
    return data;
  },

  async getDealFiles(dealId: string): Promise<DealWithFiles> {
    const { data } = await api.get(`/contracts/${dealId}/files`);
    return data;
  },

  async getFileSignedUrl(fileId: string): Promise<string> {
    const { data } = await api.get(`/contracts/file/${fileId}/url`);
    return data.url;
  },
};
